import { PatientIntakeBundle } from "~/common/utils/consultations/intake/interfaces";
import { ScreeningCompletedAndIntakeStartedCard } from "~/patients/components";
import {
  CompletedConsultationCard,
  PendingConsultationCard,
} from "~/patients/components/consultations/shared/ui/cards";

interface ConsultationCardProps {
  completed?: boolean;
  title: string;
  subtitle?: string;
  handleCompleteConsultation: () => void;
  isAutoPromotePatient?: boolean;
  intakeData?: PatientIntakeBundle;
}

export const ConsultationCard = ({
  completed,
  title,
  subtitle,
  handleCompleteConsultation,
  isAutoPromotePatient,
  intakeData,
}: ConsultationCardProps) => {
  if (intakeData && completed) {
    return <CompletedConsultationCard title={title} />;
  }

  if (intakeData) {
    return (
      <PendingConsultationCard
        title={title}
        duration={intakeData.duration}
        totalSections={intakeData.total_sections}
        currentSection={intakeData.sections_completed}
        subtitle={subtitle}
        handleCompleteConsultation={handleCompleteConsultation}
      />
    );
  }

  return isAutoPromotePatient ? (
    <ScreeningCompletedAndIntakeStartedCard title={title} />
  ) : null;
};
